/**
 * Timbrica WebRTC Shared Config
 * Used by all PeerJS-based tools: walkie-talkie, video-call, baby-monitor,
 * live-audio, video-surveillance, volleyball-game
 */
(function(w){
    'use strict';

    /* ---- PeerJS: уходящий пир закрывает ВСЕ свои соединения ----
       Sentry TIMBRICA-FRONTEND-MG (/ru/video-surveillance): «Cannot read
       properties of null (reading '_initializeDataChannel')» в PeerJS
       `e.ondatachannel`. Дефект в самой библиотеке 1.5.5 — и в той сборке, что
       лежит у нас в /vendor/peerjs (RU), и в копии jsDelivr, которую грузит
       intl (config/vendor.php); в upstream master он тоже есть:
           _cleanupPeer(e){ let n=this._connections.get(e); if(n) for(let r of n) r.close() }
       close() каждого соединения зовёт provider._removeConnection(this), а тот
       делает splice ТОГО ЖЕ массива посреди обхода — итератор перескакивает
       через соседа, и закрывается каждое ВТОРОЕ соединение. После destroy()
       или LEAVE от брокера запись пира из реестра удалена, пропущенное
       соединение живо; его data channel открывается позже, getConnection()
       отвечает null — и падает обработчик внутри библиотеки. Камера держит на
       каждого зрителя канал данных и медиазвонок, разговор и переподключение
       добавляют ещё: четыре соединения → два открытыми (замер в node на обоих
       бандлах — tests/js/peerjs-cleanup-closes-every-connection.test.mjs).

       Почему правка — в прототипе библиотеки, а не у вызывающих:
         · destroy() зовётся из 36 мест в 14 файлах (grep 26.09) — чинить
           каждое значит пропустить следующее;
         · путь LEAVE вообще не наш: брокер сообщает, что зритель ушёл, и
           _cleanupPeer зовёт сама библиотека, из обработчика сообщения;
         · исправленный файл под прежним именем /vendor/peerjs/peerjs.min.js
           до вернувшихся не доедет — /vendor/ отдаётся immutable на 180 дней,
           а intl берёт копию jsDelivr, которую мы не правим вовсе.
       Замена закрывает КОПИЮ списка (каждый close() всё так же вынимает себя
       из реестра) и не даёт одному бросившему close() оборвать остальные.
       Ставится при загрузке и ещё раз в createPeer()/peerOptions(): страница
       может подключать этот файл РАНЬШЕ библиотеки (/interview-studio). Если
       новая версия PeerJS переименует внутренности, заплатка ничего не тронет,
       а тест выше покраснеет — тихо превратиться в no-op ей не дадут. */
    var CLOSES_A_COPY = '__timbricaClosesACopy';
    function patchPeerCleanup(){
        var P = (typeof Peer !== 'undefined') ? Peer : null;
        var proto = P && P.prototype;
        var orig = proto && proto._cleanupPeer;
        if (typeof orig !== 'function') return false;
        if (orig[CLOSES_A_COPY]) return true;
        var fixed = function(peerId){
            var map = this._connections;
            var list = (map && typeof map.get === 'function') ? map.get(peerId) : null;
            if (!list || typeof list.slice !== 'function') return orig.apply(this, arguments);
            list.slice().forEach(function(c){ try { c.close(); } catch(_){} });
        };
        fixed[CLOSES_A_COPY] = true;
        proto._cleanupPeer = fixed;
        return true;
    }
    patchPeerCleanup();

    /* Two WebRTC regions, one per half of the site (since 2026-09-26).
         ru   — the RU box (ru2, Selectel, since 03.11.2026; Beget before):
                broker timbrica.com/peer, coturn timbrica.com.
         intl — NL origin: broker rtc.tembrica.com/peer, coturn rtc.tembrica.com
                (a DNS-only name: TURN cannot pass the Cloudflare proxy).
       Before this, pages of BOTH domains signalled and relayed through Beget,
       so banning a tool on timbrica.com never took its foreign users off
       Russian infrastructure.

       A room lives on ONE broker, so both ends of an invite link must resolve
       the same region. The server decides it from the page's LOCALE and
       renders window.__RTC_REGION in <head> (rtc_region() in app/helpers.php):
       the locale is part of the link and survives the RU geo-302 between the
       domains, the host does not. Pages without the main layout (/pino) fall
       back to the host here. room-connect.js and room-connect-mesh.js carry
       the same broker table as their fallback — RoomBrokerFallbackMatchesConfigTest.

       Credentials are public by design (every TURN credential that reaches a
       browser is); the NL box bounds abuse in its firewall, see
       infra/webrtc/nl-coturn-fw.sh.

       Own STUN/TURN first; a third-party STUN only as a second opinion when
       ours does not answer. Priority: own STUN → own TURN (UDP/TCP/TLS) →
       EXTRA_STUN of the region. */
    var PEER_SERVERS = {
        ru:   { host: 'timbrica.com', port: 443, path: '/peer', secure: true, key: 'timbrica' },
        intl: { host: 'rtc.tembrica.com', port: 443, path: '/peer', secure: true, key: 'timbrica' }
    };
    var TURN = {
        ru:   { host: 'timbrica.com', username: 'timbrica', credential: 'b473dc3d35554085809e565b' },
        intl: { host: 'rtc.tembrica.com', username: 'tembrica', credential: '27d3481fd6d6af7ae1d82465' }
    };
    /* Whether a tool that sets window.__NO_TURN (walkie-talkie, file-transfer,
       private-chat, screen-share — communication BETWEEN people) may still be
       relayed. On Russian infrastructure it may not (149-ФЗ: our server must not
       carry communications). The NL relay is outside that law, and without it a
       viewer behind strict NAT never connects: 563 of 4627 intl screen-share
       viewers in 30 days (12%) ended on p2p_timeout. Media stays end-to-end
       encrypted through a relay (DTLS-SRTP), the relay only forwards packets. */
    var RELAY_INTERPERSONAL = { ru: false, intl: true };

    function regionFromHost(host){
        return /(^|\.)tembrica\.com$/i.test(String(host || '')) ? 'intl' : 'ru';
    }
    function currentRegion(){
        var r = w.__RTC_REGION;
        if (r && PEER_SERVERS[r]) return r;
        return regionFromHost(w.location && w.location.hostname);
    }
    /* An explicit region (support door, consult call) wins; anything unknown
       means this page's own region. */
    function regionOr(region){
        return (region && PEER_SERVERS[region]) ? region : currentRegion();
    }
    /* Google STUN does not answer from Russia: measured 04.11.2026 from the RU
       box and an RU access line — stun.l.google.com / stun1 silent, Cloudflare
       (stun.cloudflare.com:3478) answers in ~11 ms; from NL both answer. A
       server that never answers only slows ICE gathering, so `ru` gets
       Cloudflare alone. `intl` keeps Google and adds Cloudflare: visitors from
       Russia land on intl-locale pages too (an English link opened in Moscow).
       docs/why/webrtc.md, «Сторонний STUN». */
    var EXTRA_STUN = {
        ru:   ['stun:stun.cloudflare.com:3478'],
        intl: ['stun:stun.cloudflare.com:3478', 'stun:stun.l.google.com:19302']
    };
    function iceServersOf(region){
        var t = TURN[region];
        return [
            { urls: 'stun:' + t.host + ':3478' },
            { urls: 'turn:' + t.host + ':3478', username: t.username, credential: t.credential },
            { urls: 'turn:' + t.host + ':3478?transport=tcp', username: t.username, credential: t.credential },
            { urls: 'turns:' + t.host + ':5349', username: t.username, credential: t.credential }
        ].concat(EXTRA_STUN[region].map(function(u){ return { urls: u }; }));
    }

    var REGION = currentRegion();
    /* Kept for direct readers (baby-monitor, video-surveillance, sound-alert
       build their own RTCPeerConnection from it): this page's region. */
    var ICE_SERVERS = iceServersOf(REGION);
    var PEER_SERVER = PEER_SERVERS[REGION];

    /* ---- Wake Lock ---- */
    var _wakeLock = null;

    function requestWakeLock(){
        if(!('wakeLock' in navigator)) return Promise.resolve(null);
        return navigator.wakeLock.request('screen').then(function(lock){
            _wakeLock = lock;
            lock.addEventListener('release', function(){ _wakeLock = null; });
            return lock;
        }).catch(function(){ return null; });
    }

    function releaseWakeLock(){
        if(_wakeLock){ try { _wakeLock.release(); } catch(e){} _wakeLock = null; }
    }

    /* ---- Peer creation helper ----
     * If the peerjs.min.js script tag failed to load (CDN miss + onerror fallback
     * racing the next <script> in the page; surfaced by Sentry TIMBRICA-FRONTEND-5B)
     * `Peer` will not exist when callers reach here. Throw a typed Error
     * instead of letting `new Peer(...)` blow up with `ReferenceError: Peer is
     * not defined` — callers (room-connect.js) catch by `err.type === 'peerjs-missing'`. */
    /* Interpersonal-comms tools (walkie-talkie, file-transfer, private-chat,
       screen-share) set window.__NO_TURN=true: in the RU region their media stays
       pure browser-to-browser P2P and is NEVER relayed through our server — this
       keeps us out of «передача коммуникаций» / ОРИ territory (149-ФЗ / 152-ФЗ).
       STUN (NAT discovery only, carries no media) stays. In the intl region the
       flag does nothing (RELAY_INTERPERSONAL above). Self-monitoring tools
       (baby-monitor, video-surveillance) and games keep TURN everywhere for
       reliable cross-NAT connectivity. */
    /* `forceTurn` — исключение для канала «пользователь → МЫ», а не лазейка в
       правиле выше. Правило звучит «не релеить коммуникации МЕЖДУ
       пользователями»; передача файла в чат поддержки идёт туда же, куда идёт
       обычное вложение, — к нам, — и релеить её через наш TURN не отличается от
       обычной загрузки. Отдельный аргумент нужен потому, что `__NO_TURN` —
       ГЛОБАЛЬНЫЙ флаг страницы: виджет поддержки живёт на любой странице, в том
       числе на /screen-share, где флаг стоит, и без явного аргумента дверь для
       большого файла молча теряла бы TURN ровно на тех страницах, где он и
       нужен для мобильных NAT. */
    function iceServersFor(forceTurn, region){
        region = regionOr(region);
        var list = iceServersOf(region);
        if (w.__NO_TURN && !forceTurn && !RELAY_INTERPERSONAL[region]){
            return list.filter(function(s){ return String(s.urls).indexOf('turn') !== 0; });
        }
        return list;
    }

    /* PeerJS options for a region: broker + ICE list. The one place where a
       peer's configuration is assembled — createPeer() below and the games
       that construct `new Peer` themselves both take it from here. */
    function peerOptions(opts){
        patchPeerCleanup();    // игры строят `new Peer` сами, но опции берут отсюда
        opts = opts || {};
        var region = regionOr(opts.region);
        var ps = PEER_SERVERS[region];
        return {
            config: { iceServers: iceServersFor(opts.forceTurn, region) },
            debug: opts.debug || 0,
            host: ps.host,
            port: ps.port,
            path: ps.path,
            secure: ps.secure,
            key: ps.key
        };
    }

    /* opts.region — only when the OTHER end decided the broker (the support
       door, where the operator's peer id names its region); otherwise the page's
       region applies. */
    function createPeer(id, opts){
        patchPeerCleanup();    // библиотека могла приехать позже этого файла
        if (typeof Peer === 'undefined') {
            var e = new Error('PeerJS library failed to load');
            e.type = 'peerjs-missing';
            throw e;
        }
        var cfg = peerOptions(opts);
        if(id){
            return new Peer(id, cfg);
        }
        return new Peer(cfg);
    }

    /* ---- Visibility change handler for reconnection ---- */
    function onVisibilityChange(callbacks){
        document.addEventListener('visibilitychange', function(){
            if(!document.hidden){
                requestWakeLock();
                if(callbacks && callbacks.onResume) callbacks.onResume();
            } else {
                if(callbacks && callbacks.onHide) callbacks.onHide();
            }
        });
    }

    /* ---- STUN RTT probe ----
       Times the first server-reflexive (`srflx`) ICE candidate from a STUN
       server. STUN is UDP — same path / packet shape as gaming traffic, so
       this RTT is a more honest baseline for cloud-gaming readiness than a
       plain HTTP RTT (which adds TCP setup + TLS + Keep-Alive on top).

       Usage:
           __WebRTC.measureStunRtt({ stun: __WebRTC.stunUrl(), timeout: 4000 })
               → Promise<{ rttMs, server, candidates, source }>
       Without `stun` it asks this page's own STUN server (stunUrl()).

       Resolves with rttMs = -1 on timeout / no srflx candidate (e.g. no UDP
       egress allowed, captive portal, etc). Caller can decide to fall back
       to HTTP RTT or surface the constraint to the user.

       Cancellation: pass an AbortSignal via opts.signal. */
    function measureStunRtt(opts) {
        opts = opts || {};
        if (typeof RTCPeerConnection !== 'function') {
            return Promise.resolve({ rttMs: -1, server: '', candidates: 0, source: 'no-rtc' });
        }
        var stunUrl = opts.stun || ownStunUrl();
        var timeoutMs = Math.max(500, Math.min(10000, opts.timeout || 4000));
        return new Promise(function(resolve){
            var pc = null;
            var srflxFirst = null;
            var candidateCount = 0;
            var settled = false;
            var t0 = (performance && performance.now) ? performance.now() : Date.now();

            function done(rttMs, source) {
                if (settled) return;
                settled = true;
                clearTimeout(killer);
                if (opts.signal) try { opts.signal.removeEventListener('abort', onAbort); } catch (_) {}
                try { if (pc) pc.close(); } catch (_) {}
                resolve({ rttMs: rttMs, server: stunUrl, candidates: candidateCount, source: source || 'srflx' });
            }
            function onAbort() { done(-1, 'aborted'); }
            if (opts.signal) {
                if (opts.signal.aborted) { resolve({ rttMs: -1, server: stunUrl, candidates: 0, source: 'aborted' }); return; }
                opts.signal.addEventListener('abort', onAbort);
            }
            var killer = setTimeout(function(){ done(-1, 'timeout'); }, timeoutMs);

            try {
                pc = new RTCPeerConnection({ iceServers: [{ urls: stunUrl }] });
                pc.onicecandidate = function(e) {
                    if (!e || !e.candidate) {
                        if (srflxFirst != null) done(srflxFirst, 'srflx');
                        else done(-1, 'no-srflx');
                        return;
                    }
                    candidateCount++;
                    var c = e.candidate.candidate || '';
                    if (c.indexOf(' typ srflx ') !== -1 && srflxFirst == null) {
                        var t1 = (performance && performance.now) ? performance.now() : Date.now();
                        srflxFirst = Math.round(t1 - t0);
                        done(srflxFirst, 'srflx');
                    }
                };
                pc.onicegatheringstatechange = function() {
                    if (pc && pc.iceGatheringState === 'complete') {
                        if (srflxFirst != null) done(srflxFirst, 'srflx');
                        else done(-1, 'no-srflx');
                    }
                };
                // Need a media or data section to trigger ICE gathering.
                pc.createDataChannel('rtt-probe');
                pc.createOffer().then(function(offer){
                    return pc.setLocalDescription(offer);
                }).catch(function(){ done(-1, 'offer-failed'); });
            } catch (e) {
                done(-1, 'rtc-error');
            }
        });
    }

    /* Our STUN server for a region — for pages that probe NAT/IP on their own
       (vpn-checker, ip-lookup, network-probe) instead of creating a peer. */
    function ownStunUrl(region){
        return 'stun:' + TURN[regionOr(region)].host + ':3478';
    }

    /* ---- Relay ledger: whose traffic our TURN relay carries ----
       The intl relay sent 97.5 GB in 12 days (2026-10-08). /screen-share reports
       its own relayed viewers — about 9 % of that — and nothing said whose the
       rest was: coturn keeps no session log, and turning one on is a restart
       that drops every relayed call. So the pages say it. Every
       RTCPeerConnection opened after this file loads is watched (PeerJS, the
       games and the tools that build their own — baby-monitor,
       video-surveillance, sound-alert — all take the global): once a minute its
       candidate pairs are read, through a relay or direct by the candidate type
       at either end, with the bytes each has carried; what moved since the last
       report goes to telemetry every 10 minutes (a night of baby monitor), when
       the page is hidden and when it goes away. Summed over a tool's pages,
       `relay_kb_sent` is what the tool costs the relay: each end counts what IT
       sent, the relay forwards both. A connection closed between two readings
       loses its last minute; nothing here may throw into a tool. */
    var LEDGER_FIRST_MS = 15000, LEDGER_TICK_MS = 60000, LEDGER_REPORT_MS = 600000;
    var LEDGER_MIN_BYTES = 16384;   // under this: STUN probes, an idle data channel
    var ledger = null;
    function ledgerZero(){ return { rs: 0, rr: 0, ds: 0, dr: 0, relayPcs: [] }; }
    function ledgerWatch(pc){
        if (!pc || typeof pc.getStats !== 'function' || typeof WeakMap !== 'function') return;
        if (!ledger) {
            ledger = { pcs: [], last: new WeakMap(), acc: ledgerZero(), sentAt: Date.now() };
            try { w.setTimeout(ledgerTick, LEDGER_FIRST_MS); w.setInterval(ledgerTick, LEDGER_TICK_MS); } catch(_){}
            try {
                if (document && document.addEventListener) {
                    document.addEventListener('visibilitychange', function(){
                        if (document.visibilityState === 'hidden') ledgerTick().then(function(){ ledgerReport('hidden'); });
                    });
                }
                if (w.addEventListener) w.addEventListener('pagehide', function(){ ledgerReport('leave'); });
            } catch(_){}
        }
        ledger.pcs.push(pc);
        ledger.last.set(pc, { rs: 0, rr: 0, ds: 0, dr: 0 });
    }
    function ledgerRead(pc){
        return pc.getStats().then(function(st){
            var type = {}, pairs = [];
            st.forEach(function(r){
                if (r.type === 'local-candidate' || r.type === 'remote-candidate') type[r.id] = r.candidateType;
                else if (r.type === 'candidate-pair') pairs.push(r);
            });
            var now = { rs: 0, rr: 0, ds: 0, dr: 0 };
            pairs.forEach(function(p){
                var relay = type[p.localCandidateId] === 'relay' || type[p.remoteCandidateId] === 'relay';
                now[relay ? 'rs' : 'ds'] += p.bytesSent || 0;
                now[relay ? 'rr' : 'dr'] += p.bytesReceived || 0;
            });
            var was = ledger.last.get(pc) || { rs: 0, rr: 0, ds: 0, dr: 0 }, relayed = false;
            ['rs', 'rr', 'ds', 'dr'].forEach(function(k){
                var d = now[k] - was[k];
                if (d > 0) { ledger.acc[k] += d; if (k === 'rs' || k === 'rr') relayed = true; }
            });
            if (relayed && ledger.acc.relayPcs.indexOf(pc) < 0) ledger.acc.relayPcs.push(pc);
            ledger.last.set(pc, now);
        });
    }
    function ledgerTick(){
        if (!ledger) return Promise.resolve();
        ledger.pcs = ledger.pcs.filter(function(pc){ return pc.signalingState !== 'closed'; });
        return Promise.all(ledger.pcs.map(function(pc){
            try { return ledgerRead(pc).catch(function(){}); } catch(_){ return null; }
        })).then(function(){
            if (Date.now() - ledger.sentAt >= LEDGER_REPORT_MS) ledgerReport('tick');
        });
    }
    function ledgerReport(why){
        if (!ledger) return;
        var a = ledger.acc;
        if (a.rs + a.rr + a.ds + a.dr < LEDGER_MIN_BYTES) return;
        var kb = function(b){ return Math.round(b / 1024); };
        // leaving: queue and flush at once — the page's own pagehide flush may already have run
        var send = (why === 'leave' && typeof w.__aeNow === 'function') ? w.__aeNow : w.__ae;
        try {
            if (typeof send === 'function') send('feature_use', {
                f: 'p2p_traffic', why: why, region: REGION,
                relay_kb_sent: kb(a.rs), relay_kb_recv: kb(a.rr),
                direct_kb_sent: kb(a.ds), direct_kb_recv: kb(a.dr),
                relay_pcs: a.relayPcs.length, pcs: ledger.pcs.length
            });
        } catch(_){}
        ledger.acc = ledgerZero();
        ledger.sentAt = Date.now();
    }
    (function ledgerInstall(){
        var Orig = w.RTCPeerConnection;
        if (typeof Orig !== 'function' || Orig.__timbricaLedger) return;
        var Ledgered = function RTCPeerConnection(){
            var args = Array.prototype.slice.call(arguments);
            var pc = (typeof Reflect !== 'undefined' && Reflect.construct)
                ? Reflect.construct(Orig, args)
                : new (Function.prototype.bind.apply(Orig, [null].concat(args)))();
            try { ledgerWatch(pc); } catch(_){}
            return pc;
        };
        Ledgered.prototype = Orig.prototype;
        try { Object.setPrototypeOf(Ledgered, Orig); } catch(_){}
        Ledgered.__timbricaLedger = true;
        w.RTCPeerConnection = Ledgered;
    })();

    /* ---- Export ---- */
    w.__WebRTC = {
        REGION: REGION,
        ICE_SERVERS: ICE_SERVERS,
        PEER_SERVER: PEER_SERVER,
        peerServerFor: function(region){ return PEER_SERVERS[regionOr(region)]; },
        iceServersFor: iceServersFor,
        peerOptions: peerOptions,
        stunUrl: ownStunUrl,
        createPeer: createPeer,
        patchPeerCleanup: patchPeerCleanup,
        requestWakeLock: requestWakeLock,
        releaseWakeLock: releaseWakeLock,
        onVisibilityChange: onVisibilityChange,
        measureStunRtt: measureStunRtt,
        // the relay ledger's hands, for its test (tests/js/webrtc-relay-ledger.test.mjs)
        _ledger: { tick: ledgerTick, report: ledgerReport }
    };
})(window);
